import ShoppingCartIcon from './ShoppingCartIcon'

export default ShoppingCartIcon
